import { requestConstantsMaker } from '../helper';

/**** 20200217 ****/
export const GET_ALL_STUDENT_REMARK = requestConstantsMaker('GET_ALL_STUDENT_REMARK');
export const GET_STUDENT_REMARK = requestConstantsMaker('GET_STUDENT_REMARK');
export const CREATE_STUDENT_REMARK = requestConstantsMaker('CREATE_STUDENT_REMARK');
export const UPDATE_STUDENT_REMARK = requestConstantsMaker('UPDATE_STUDENT_REMARK');
export const DELETE_STUDENT_REMARK = requestConstantsMaker('DELETE_STUDENT_REMARK');
export const GET_STUDENT_REMARKS_FOR_STUDENT_DETAIL = requestConstantsMaker('GET_STUDENT_REMARKS_FOR_STUDENT_DETAIL');
/**** 20200217 ****/

export const GET_ALL_STUDENT_REMARK_BY_SPECIFICATION = requestConstantsMaker('GET_ALL_STUDENT_REMARK_BY_SPECIFICATION');
export const POST_CREATE_STUDENT_REMARK = requestConstantsMaker('POST_CREATE_STUDENT_REMARK');